import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import userManager from "../auth/UserManager";

const Callback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // console.log("Callback");
    userManager
      .signinRedirectCallback()
      .then(() => {
        console.log('callback in');
        navigate("/");
      })
      .catch((error) => {
        console.error(error);
      });
  }, [navigate]);

  return <div>Loading...</div>;
};

export default Callback;
